export default "__VITE_ASSET__COO8_HXu__"